import { escapeHtml } from "@/scripts/helpers";
import * as Sentry from "@sentry/vue";
import { useFirebase } from "@/composables/useFirebase";

export const useAssistant = () => {
  const { postData } = useApi();

  const chatStore = useChatStore();

  const assistantForm = reactive({
    message: "",
  });

  const errorShown = ref(false);

  const { logEvent } = useFirebase();

  const assistantAsk = async (message: string) => {
    // Don't send request when still awaiting response
    if (chatStore.awaitingReply) return;
    // Log event to firebase
    logEvent("submit_chat_message");
    // Set pending state
    chatStore.awaitingReply = true;
    // Add user message to the messages array
    chatStore.addMessage(escapeHtml(message), "user");
    // Try to fetch a response from the api
    try {
      const response = await postData("/ask", {
        message,
        chat_id: chatStore.id,
      });
      // Log event to firebase
      logEvent("receive_reply");
      // Update the chat id in case we received a new one
      chatStore.id = response.data.chat_id;
      // Add assistant message to the messages array
      chatStore.addMessage(
        response.data.content,
        "assistant",
        response.data.id,
        response.data.rich_data,
      );
    } catch (e: unknown) {
      // Send error to Sentry
      Sentry.captureException(e);
      // Show error messages to the user
      if (errorShown.value) {
        chatStore.addMessage(
          "Ik kan op dit moment helaas geen antwoord geven op jouw vraag, probeer het later opnieuw.",
        );
      } else {
        chatStore.addMessage(
          "Sorry, maar ik denk dat mijn internet er even uit ligt 🫠 Ik ga direct op onderzoek uit en hopelijk ben ik snel weer online!",
          "assistant",
        );
        errorShown.value = true;
      }
    }
    // Reset pending state
    chatStore.awaitingReply = false;
  };

  // const getSeperateMessages = (message: string) => {
  //   // Split response into array at double linebreak
  //   return message.split(/\n\s*\n/);
  // };

  return {
    assistantForm,
    assistantAsk,
  };
};
